import CrownIcon from "@/components/Crown";
import { NAV_LINKS, HOURS, scrollToId } from "@/lib/site";

export default function Footer() {
    return (
        <footer
            data-testid="footer-container"
            className="bg-obsidian border-t border-gold/15"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    <div>
                        <div className="flex items-center gap-3">
                            <span className="text-gold">
                                <CrownIcon size={26} />
                            </span>
                            <span className="font-display font-bold text-lg tracking-[0.18em] text-white">
                                CORTE <span className="text-gold">NOBRE</span>
                            </span>
                        </div>
                        <p className="mt-5 text-sm text-cream/55 leading-relaxed max-w-xs">
                            Barbearia de elite em João Pessoa — tradição, precisão e
                            sofisticação em cada detalhe do ritual.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-xs uppercase tracking-[0.3em] text-gold font-semibold mb-5">
                            Navegação
                        </h4>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollToId(l.href);
                                        }}
                                        className="text-sm text-cream/60 hover:text-gold transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs uppercase tracking-[0.3em] text-gold font-semibold mb-5">
                            Horários
                        </h4>
                        <ul className="space-y-3">
                            {HOURS.map((h) => (
                                <li key={h.days} className="text-sm text-cream/60 flex justify-between gap-4">
                                    <span>{h.days}</span>
                                    <span className="font-mono text-cream/80">{h.time}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-7 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-cream/45 text-center sm:text-left">
                        © 2026 Corte Nobre Barbearia — Todos os direitos reservados.
                    </p>
                    <p className="text-[11px] font-mono text-cream/35 text-center sm:text-right">
                        Site fictício de demonstração · Nenhuma informação de contato é real
                    </p>
                </div>
            </div>
        </footer>
    );
}
